var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React from 'react';
function Chip(_a) {
    var { showLabel = true } = _a, params = __rest(_a, ["showLabel"]);
    return (React.createElement("div", { className: "qmb-chip", style: { display: 'flex', gap: '.5rem', alignItems: 'center' } },
        params.icon && React.createElement("span", null, params.icon),
        showLabel && React.createElement("span", null, params.label)));
}
export default Chip;
